<template>
  <h2 class="section__title section__title--error">{{ $t('main-page.rejected.back-to-pharmacy.pending-back-to-pharmacy') }}</h2>
</template>

<script>
export default {
  name: 'pending-back-to-pharmacy',
}
</script>
